import React from "react";
import BackButton from "components/BackButton";

const About: React.FC = () => {
  return (
    <div className="bg-[#BCB7A8] font-['IBM_Plex_Mono',monospace] text-black m-0 p-0 flex flex-col justify-start items-center h-[100vh]">
      <div className="container w-auto h-full p-3 overflow-auto md:mt-5 md:max-w-[900px]">
        <div className="header text-[2rem] font-bold leading-[1.6] mb-8">
          A Wetland Role-Playing Game to Activate Pluriversal Perspectives
        </div>

        <p className="mb-6 text-xl leading-relaxed">
          Wetland Role-Playing Game to Activate Pluriversal Perspectives is an agent-based platform to foster multi-species perspectives among users in environmental planning and support multi-natural intelligence.
        </p>

        <p className="mb-6 text-xl leading-relaxed">
          Developed as educational tool that could be enacted as performance, the Wetland Game emphasizes entanglement of landscape and humans and their inseparability in maintaining an equilibrium in between autochthonous and invasive, preservation and economy, many natures and many cultures.
        </p>

        <p className="mb-6 text-xl leading-relaxed">
          Envisioned as an update and adaptation project of the ButorStar* role-playing game and based on the interdisciplinary scientific works on Camargue marsh in France, the Wetland Game simulates the impacts of diverse factors: sea level and salinity dynamics, volatile climate and economy informing decisions made by various “stakeholders” of the wetland, i.e. farmers, fishers, livestock breeders, reed harvesters, hunters, conservationists, but also birds and plants, allowing players to explore the “pluriverse”, to use the anthropologist Arturo Escobar’s expression.
        </p>

        <p className="mb-6 text-xl leading-relaxed">
          Wetland Game creates a continuum of learning from other species that crosses the traditional boundaries between disciplines (geography, ecology, economy, anthropology) and allows participants to conduct multipurpose experiments that contribute to their understanding of socio-ecosystems and sustainability respecting the plurality of wetland beings’ perspectives.
        </p>
      </div>

      <div className="footer fixed bottom-8 left-8 w-[100vw]">
        <BackButton />
      </div>
    </div>
  );
};

export default About;
